import type { SpotCategory } from '@ridehub/shared';
import { getCategoryLabel, CATEGORY_MAP } from '@ridehub/shared';

interface CategoryIconProps {
  category: SpotCategory;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

const sizeClasses = { sm: 'text-lg', md: 'text-2xl', lg: 'text-4xl' };

export function CategoryIcon({ category, size = 'md', showLabel = false }: CategoryIconProps) {
  const def = CATEGORY_MAP.get(category);
  const icon = def?.icon ?? '📍';

  return (
    <span className="inline-flex items-center gap-1">
      <span className={sizeClasses[size]} role="img" aria-label={getCategoryLabel(category)}>
        {icon}
      </span>
      {showLabel && <span className="text-sm text-gray-600">{getCategoryLabel(category)}</span>}
    </span>
  );
}
